import "./css/video.css" // दोनों के लिए एक ही CSS इस्तेमाल कर सकते हैं

const UnderConstruction = () => {
    return (
        <div className="constructionContainer">
            <div className="messageBox">
                <div className="iconWrapper">
                    <i className="fa-solid fa-person-digging"></i>
                </div>
                <h3>Coming Soon</h3>
                <p>
                    Our website is currently under development. This service will be available <span>very soon</span>, bringing you innovative features and reliable performance. We appreciate your patience!
                </p>
            </div>
        </div>
    );
};
export default UnderConstruction;